import { useState } from "react";
import { Head } from "@inertiajs/react";
import DashboardLayout from "@/frontend/layouts/DashboardLayout";
import DataHub from "@/frontend/features/Fde/data/DataHub";
import FdeShell from "@/frontend/features/Fde/FdeShell";
import ForgePane from "@/frontend/features/Fde/ForgePane";
import ForgeStage from "@/frontend/features/Fde/ForgeStage";
import ProjectControls from "@/frontend/features/Fde/ProjectControls";
import ProjectDialog from "@/frontend/features/Fde/ProjectDialog";
import type { Project } from "@/frontend/features/Fde/types";
import type { DataProps } from "@/frontend/features/Fde/data/types";
import { fdeRoutes } from "@/frontend/features/Fde/routes";

function DataPage(props: DataProps & { is_stationzero_admin: boolean }) {
  const [projectDialog, setProjectDialog] = useState<{
    open: boolean;
    project: Project | null;
  }>({ open: false, project: null });
  const section = props.copy.sections.data;
  const actions = (
    <ProjectControls
      path={fdeRoutes.data}
      project={props.project}
      projects={props.project_history}
      copy={props.copy}
      canManage={props.can_manage}
      onEdit={() => setProjectDialog({ open: true, project: props.project })}
      onNew={() => setProjectDialog({ open: true, project: null })}
    />
  );

  return (
    <>
      <Head title={props.page_title} />
      <FdeShell
        copy={props.copy}
        eyebrow=""
        title={props.project?.name ?? props.organization.name}
        description={section.description}
        actions={actions}
        projectId={props.project?.id}
      >
        <ForgeStage
          props={props}
          primaryLabel={section.title}
          refreshProps={["data"]}
          allowWithoutProject
          renderPrimary={(headerActions) => (
            <ForgePane
              title={section.title}
              description={section.description}
              hideHeader
            >
              <DataHub
                data={props.data}
                projectId={props.project?.id}
                copy={props.copy.data}
                canManage={props.can_manage}
                isAdmin={props.is_stationzero_admin}
                workspaceActions={headerActions}
              />
            </ForgePane>
          )}
        />
      </FdeShell>
      <ProjectDialog
        open={projectDialog.open}
        onOpenChange={(open) =>
          setProjectDialog((current) => ({ ...current, open }))
        }
        project={projectDialog.project}
        agents={props.agents}
        copy={props.copy}
        activeProjectId={props.project?.id}
      />
    </>
  );
}

DataPage.layout = (page: React.ReactElement) => (
  <DashboardLayout variant="fullscreen">{page}</DashboardLayout>
);
export default DataPage;
